import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('If an account with that email exists, we have sent a password reset link.');
            } else {
                setError(data.error || 'Failed to process request');
            }
        } catch (err) {
            setError('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-wrapper" style={{ backgroundImage: 'linear-gradient(rgba(27, 38, 49, 0.9), rgba(13, 18, 23, 0.9)), url(/Sunnyday_Snapshots/site_view.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="login-container">
                <div className="login-info-panel">
                    <div className="login-info-content">
                        <h2>Password Recovery</h2>
                        <p>
                            Enter your registered email address and we will securely email you a link to reset your password.
                        </p>
                        <img src="/Sunnyday_Snapshots/site_image_4.jpeg" alt="Observant Security Site" style={{ width: '100%', borderRadius: '8px', marginTop: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.3)' }} />
                    </div>
                </div>

                <div className="login-form-panel">
                    <h2>Forgot Password</h2>
                    <p className="form-subtitle">Secure Account Recovery</p>

                    {error && <div className="error-message">{error}</div>}
                    {message && <div style={{ backgroundColor: 'rgba(40, 167, 69, 0.1)', color: '#28a745', padding: '12px', borderRadius: '6px', marginBottom: '20px', textAlign: 'center', border: '1px solid rgba(40, 167, 69, 0.2)', fontSize: '0.95rem' }}>{message}</div>}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="name@company.com"
                            />
                        </div>
                        <button type="submit" className="login-btn" disabled={loading}>
                            {loading ? 'Processing...' : 'Send Reset Link'}
                        </button>
                    </form>

                    <div className="auth-links" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <Link to="/login" style={{ color: '#1B2631' }}>Return to Login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
